import { status } from 'skin/event/status';

const ignore = (obj, form, story, data, d, action) => {
	return status.ignore;
};

export default ignore;
